var $d315d8146c46cfd9$exports = {};
$d315d8146c46cfd9$exports = {
    "loading": `Cargando\u{2026}`,
    "placeholder": `Seleccione\u{2026}`
};


export {$d315d8146c46cfd9$exports as default};
//# sourceMappingURL=es-ES.mjs.map
